import { IntlShape } from "react-intl";

export const getAnalyticsDashboardFormattedString = (intl: IntlShape) => ({
  analyticsMetricGroupNameDauMau: intl.formatMessage({
    defaultMessage: "Usage by time periods",
    description: "Name for the header that groups the DAU (DailyActiveUsers), WAU (WeeklyActiveUsers), R28MAU (28 days MonthlyActiveUsers Agg), R30MAU (30 days Monthly Agg).",
  }),
  analyticsMetricGroupNameRetention: intl.formatMessage({
    defaultMessage: "Usage by retention state",
    description: "Name for the header that groups the New MAU, ReturningMAU, RessurectedMAU, Lapsed MAU metrics.",

  }),
  analyticsMetricGroupNamePlatform: intl.formatMessage({
    defaultMessage: "Usage by platform and OS (MAU)",
    description: "Name for the header that groups the Windows, Mac, Web, iOS, android user metrics.",
  }),
  analyticsMetricGroupNameIntensity: intl.formatMessage({
    defaultMessage: "Usage intensity",
    description: "Name for the header that groups the Median Days used, percentage of days used and mau/dau ratio.",
  }),
  analyticsMetricNameMau30: intl.formatMessage({
    defaultMessage: "Monthly R30 active users (MAU)",
    description: "Name for the given metric row in the analytics page. For metric explanation see analyticsMetricTooltipTextMau30",
  }),
  analyticsMetricNameMau28: intl.formatMessage({
    defaultMessage:
      "Monthly R28 active users",
    description: "Name for the given metric row in the analytics page. For metric explanation see analyticsMetricTooltipTextMau28",
  }),
  analyticsMetricNameWau: intl.formatMessage({
    defaultMessage: "Weekly R7 active users (WAU)",
    description: "Name for the given metric row in the analytics page. For metric explanation see analyticsMetricTooltipTextWau",
  }),
  analyticsMetricNameDau: intl.formatMessage({
    defaultMessage: "Daily active users (DAU)",
    description: "Name for the given metric row in the analytics page. For metric explanation see analyticsMetricTooltipTextDau",
  }),
  analyticsMetricNameWindowsUsers: intl.formatMessage({
    defaultMessage: "Windows",
    description: "Name for the given metric row in the analytics page. For metric explanation see analyticsMetricTooltipTextWindowsUsers",
  }),
  analyticsMetricNameMacUsers: intl.formatMessage({
    defaultMessage: "Mac",
    description: "Name for the given metric row in the analytics page. For metric explanation see analyticsMetricTooltipTextMacUsers",
  }),
  analyticsMetricNameWebUsers: intl.formatMessage({
    defaultMessage: "Web",
    description: "Name for the given metric row in the analytics page. For metric explanation see analyticsMetricTooltipTextWebUsers",
  }),
  analyticsMetricNameAndroidUsers: intl.formatMessage({
    defaultMessage: "Android",
    description: "Name for the given metric row in the analytics page. For metric explanation see analyticsMetricTooltipTextAndroidUsers",
  }),
  analyticsMetricNameIosUsers: intl.formatMessage({
    defaultMessage: "iOS",
    description: "Name for the given metric row in the analytics page. For metric explanation see analyticsMetricTooltipTextIosUsers",
  }),
  analyticsMetricNameNewMau: intl.formatMessage({
    defaultMessage: "New users (MAU)",
    description: "Name for the given metric row in the analytics page. For metric explanation see analyticsMetricTooltipTextNewMau",
  }),
  analyticsMetricNameReturningMau: intl.formatMessage({
    defaultMessage: "Returning users (MAU)",
    description: "Name for the given metric row in the analytics page. For metric explanation see analyticsMetricTooltipTextReturningMau",
  }),
  analyticsMetricNameResurrectedMau: intl.formatMessage({
    defaultMessage: "Resurrected users (MAU)",
    description: "Name for the given metric row in the analytics page. For metric explanation see analyticsMetricTooltipTextResurrectedMau",
  }),
  analyticsMetricNameLapsedMau: intl.formatMessage({
    defaultMessage: "Lapsed users (MAU)",
    description: "Name for the given metric row in the analytics page. For metric explanation see analyticsMetricTooltipTextLapsedMau",
  }),
  analyticsMetricNameMedianDays: intl.formatMessage({
    defaultMessage: "Median days used per month",
    description: "Name for the given metric row in the analytics page. For metric explanation see analyticsMetricTooltipTextMedianDays",
  }),
  analyticsMetricNamePercentDays: intl.formatMessage({
    defaultMessage: "% of 5+ days usage",
    description: "Name for the given metric row in the analytics page. For metric explanation see analyticsMetricTooltipTextPercentDays",
  }),
  analyticsMetricNameRatio: intl.formatMessage({
    defaultMessage: "DAU/MAU",
    description: "Name for the given metric row in the analytics page. For metric explanation see analyticsMetricTooltipTextRatio",
  }),
  analyticsMetricTooltipTextMau30: intl.formatMessage({
    defaultMessage: "The count of unique users who have used your app or service during the selected R30 time period.",
    description: "Tooltip shown when the metric is hovered over. Explains what the calculation for the metric is.",
  }),
  analyticsMetricTooltipTextMau28: intl.formatMessage({
    defaultMessage: "The count of unique users who have used your app or service during the selected R28 time period.",
    description: "Tooltip shown when the metric is hovered over. Explains what the calculation for the metric is.",
  }),
  analyticsMetricTooltipTextWau: intl.formatMessage({
    defaultMessage: "The count of unique users who have used your app or service during the selected R7 time period.",
    description: "Tooltip shown when the metric is hovered over. Explains what the calculation for the metric is.",
  }),
  analyticsMetricTooltipTextDau: intl.formatMessage({
    defaultMessage: "The count of unique users who have used your app or service during the selected day.",
    description: "Tooltip shown when the metric is hovered over. Explains what the calculation for the metric is.",
  }),

  analyticsMetricTooltipTextWindowsUsers: intl.formatMessage({
    defaultMessage: "Monthly R30 Active Users on a PC running a Mac operating system. Does not include Web, Universal, or Mobile usage on a Mac device.",
    description: "Tooltip shown when the metric is hovered over. Explains what the calculation for the metric is.",
  }),
  analyticsMetricTooltipTextMacUsers: intl.formatMessage({
    defaultMessage: "Monthly R30 Active Users on a PC running a Mac operating system. Does not include Web, Universal, or Mobile usage on a Mac device.",
    description: "Tooltip shown when the metric is hovered over. Explains what the calculation for the metric is.",
  }),
  analyticsMetricTooltipTextWebUsers: intl.formatMessage({
    defaultMessage: "Monthly R30 Active Users accessing services via a web browser. This includes web on Windows, web on Mac, web on Android, and web on iOS.",
    description: "Tooltip shown when the metric is hovered over. Explains what the calculation for the metric is.",
  }),
  analyticsMetricTooltipTextAndroidUsers: intl.formatMessage({
    defaultMessage: "Monthly R30 Active Users on on an Android device.",
    description: "Tooltip shown when the metric is hovered over. Explains what the calculation for the metric is.",
  }),
  analyticsMetricTooltipTextIosUsers: intl.formatMessage({
    defaultMessage: "Monthly R30 Active Users on an iOS device during the selected R30 time period. Includes iPhones and IPads.",
    description: "Tooltip shown when the metric is hovered over. Explains what the calculation for the metric is.",
  }),
  analyticsMetricTooltipTextNewMau: intl.formatMessage({
    defaultMessage: "Active Users who used your app in the last R30 period and had never been seen before since June 1, 2020.",
    description: "Tooltip shown when the metric is hovered over. Explains what the calculation for the metric is.",
  }),
  analyticsMetricTooltipTextReturningMau: intl.formatMessage({
    defaultMessage: "Active Users who used your app during the selected R30 time period and the previous R30 time period.",
    description: "Tooltip shown when the metric is hovered over. Explains what the calculation for the metric is.",
  }),
  analyticsMetricTooltipTextResurrectedMau: intl.formatMessage({
    defaultMessage: "Active Users who have used your app one or more times since June 1, 2020 but not in the immediately previous R30 time period.",
    description: "Tooltip shown when the metric is hovered over. Explains what the calculation for the metric is.",
  }),
  analyticsMetricTooltipTextLapsedMau: intl.formatMessage({
    defaultMessage: "Active Users who were not seen during the selected R30 time period but were seen during the previous R30 time period.",
    description: "Tooltip shown when the metric is hovered over. Explains what the calculation for the metric is.",
  }),
  analyticsMetricTooltipTextMedianDays: intl.formatMessage({
    defaultMessage: "Median number of days that users used your app during the selected R30 time period.",
    description: "Tooltip shown when the metric is hovered over. Explains what the calculation for the metric is.",
  }),
  analyticsMetricTooltipTextPercentDays: intl.formatMessage({
    defaultMessage: "% of Monthly R30 Active Users that used your app at least 5+ days in the month.",
    description: "Tooltip shown when the metric is hovered over. Explains what the calculation for the metric is.",
  }),
  analyticsMetricTooltipTextRatio: intl.formatMessage({
    defaultMessage: "Daily Active Users/Monthly Active Users (DAU/MAU) is the ratio of the average number of unique users who used your app on each day divided by the Monthly Active Users for the selected R30 time period.",
    description: "Tooltip shown when the metric is hovered over. Explains what the calculation for the metric is.",
  }),
})